import React from 'react'
import DataGrid from '../../../../table/DataGrid'
import TextValue from '../../../../text/TextValue'
import { Box, Table, TableContainer, TableBody, TableRow, TableCell, Chip, Typography } from '@mui/material'
import groupBy from 'lodash/groupBy'
import isEmpty from 'lodash/isEmpty'
import pluralize from 'pluralize'

const TableCompareUpsert = ({ module = '', type = '', status, description, data = [] }) => {
  return (
    <Box className='flex flex-col gap-4 pt-4'>
      {data?.length > 0 && (
        <div className='h-screen-1/3 relative'>
          <DataGrid
            id='table-compare-import'
            showSetting={false}
            rows={data
              .sort((a, b) => b.code - a.code)
              .map((row, index) => ({
                ...row,
                index: index + 1,
                module: row.name || row.dataId || row.yearId,
                fields: (
                  <div className='bg-muted text-2xs'>
                    <pre>{JSON.stringify(row, null, 2)}</pre>
                  </div>
                ),
                _id: row._id ? row._id : index
              }))}
            rowsPerPage={data?.length || 0}
            columns={[
              { label: '#', key: 'index', align: 'center', show: true, hide: false },
              { label: 'Name', key: 'module', width: '160px', show: true, hide: false },
              { label: 'fields', key: 'fields', show: true, hide: false }
            ]}
            labelNoRows="You don't have any changes yet"
          />
        </div>
      )}
    </Box>
  )
}
export default TableCompareUpsert
